import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
// Gonna do something weird here with the context default value. This will NEVER be used since
// We require the Tab, TabList, and TabPanel to be used within Tabs.
var TabsContext = /*#__PURE__*/createContext({});
export var TabsContextProvider = function TabsContextProvider(_ref) {
  var children = _ref.children,
    manual = _ref.manual,
    onChange = _ref.onChange,
    onlyRenderActiveTabPanelChildren = _ref.onlyRenderActiveTabPanelChildren,
    renderOn = _ref.renderOn,
    selectedId = _ref.selectedId;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    tabRegistrations = _useState2[0],
    setTabRegistrations = _useState2[1];
  var registerTab = useCallback(function (tabId, ref) {
    setTabRegistrations(function (prev) {
      var exists = prev.find(function (tab) {
        return tab.tabId === tabId;
      });
      if (exists) {
        return prev;
      } else {
        return [].concat(_toConsumableArray(prev), [{
          tabId: tabId,
          tabRef: ref,
          panelId: null,
          panelRef: null
        }]);
      }
    });
    return {
      unregister: function unregister() {
        setTabRegistrations(function (prev) {
          return prev.filter(function (tab) {
            return tab.tabId !== tabId;
          });
        });
      }
    };
  }, []);
  var registerTabPanel = useCallback(function (panelId, ref) {
    // Load this panel's reg into the first open slot in the tab registrations.
    setTabRegistrations(function (prev) {
      var nextEmptyTabReg = prev.find(function (tab) {
        return !tab.panelRef;
      });
      if (nextEmptyTabReg) {
        return prev.map(function (tab) {
          if (tab.tabId === nextEmptyTabReg.tabId) {
            return _objectSpread(_objectSpread({}, tab), {}, {
              panelRef: ref,
              panelId: panelId
            });
          } else {
            return tab;
          }
        });
      }
      return prev;
    });
    return {
      unregister: function unregister() {
        setTabRegistrations(function (prev) {
          return prev.map(function (tab) {
            var _tab$panelRef;
            if ((_tab$panelRef = tab.panelRef) !== null && _tab$panelRef !== void 0 && _tab$panelRef.current && tab.panelRef.current === ref.current) {
              return _objectSpread(_objectSpread({}, tab), {}, {
                panelRef: null
              });
            } else {
              return tab;
            }
          });
        });
      }
    };
  }, []);
  var moveFocusBy = useCallback(function (amount) {
    var selectedIndex = tabRegistrations.findIndex(function (_ref2) {
      var tabRef = _ref2.tabRef;
      return tabRef.current === document.activeElement;
    });
    var nextIndex = selectedIndex + amount;
    if (nextIndex >= 0 && nextIndex < tabRegistrations.length) {
      if (manual) {
        var _tabRegistrations$nex;
        (_tabRegistrations$nex = tabRegistrations[nextIndex].tabRef.current) === null || _tabRegistrations$nex === void 0 ? void 0 : _tabRegistrations$nex.focus();
      } else {
        onChange(tabRegistrations[nextIndex].tabId);
      }
    }
  }, [manual, onChange, tabRegistrations]);
  var focusPreviousTab = useCallback(function () {
    moveFocusBy(-1);
  }, [moveFocusBy]);
  var focusNextTab = useCallback(function () {
    moveFocusBy(1);
  }, [moveFocusBy]);
  var memoizedValue = useMemo(function () {
    return {
      manual: manual,
      onChange: onChange,
      onlyRenderActiveTabPanelChildren: onlyRenderActiveTabPanelChildren,
      registerTab: registerTab,
      registerTabPanel: registerTabPanel,
      renderOn: renderOn,
      selectedId: selectedId,
      focusNextTab: focusNextTab,
      focusPreviousTab: focusPreviousTab,
      tabRegistrations: tabRegistrations
    };
  }, [manual, onChange, onlyRenderActiveTabPanelChildren, registerTab, registerTabPanel, renderOn, selectedId, focusNextTab, focusPreviousTab, tabRegistrations]);
  return /*#__PURE__*/React.createElement(TabsContext.Provider, {
    value: memoizedValue
  }, children);
};
export var useTabsContext = function useTabsContext() {
  return useContext(TabsContext);
};
//# sourceMappingURL=TabsContext.js.map